<script setup lang="ts">
withDefaults(
  defineProps<{
    label?: string
    labelHtml?: string
    icon?: { path: IconPath; size?: number } | null
  }>(),
  {
    icon: null,
    label: '',
    labelHtml: '',
  },
)
</script>

<template>
  {{ label }}
  <BaseFormComponentsBaseStringToHtml v-if="labelHtml" :str-html="labelHtml" />
  <BaseIcon v-if="icon" :name="icon.path" :size="icon.size" />
</template>
